import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "mb-2" };
const _hoisted_2 = { class: "my-8" };
import useCompanyUser from '@/composables/useCompanyUser';
import useContract from '@/composables/useContract';
import useMessage from '@/composables/message/useMessage';
import useSuperAdminUser from '@/composables/useSuperAdminUser';
import { createMessageDto } from '@/dtos/messageDto';
import { computed, onMounted, ref } from 'vue';
import { CONTRACT_STATUSES } from '@/constants/constants';
import { createContractDtoFromModel } from '@/dtos/contractDto';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChangeStatusForm',
    props: {
        contract: Object,
        newStatus: Number,
    },
    emits: ['updated', 'canceled'],
    setup(__props, { emit: __emit }) {
        const { companyUsers, fetchCompanyUsersByJobId } = useCompanyUser();
        const { contracts, updateContracts } = useContract();
        const { storeMessages } = useMessage();
        const { superAdminUser, fetchSuperAdminUser } = useSuperAdminUser();
        const messageToCompanyUserIds = ref([]);
        const messageToCompany = ref('');
        const messageToPlanner = ref('');
        const title = computed(() => {
            const before = CONTRACT_STATUSES.find((s) => s.value === props.contract?.status)?.text;
            const after = CONTRACT_STATUSES.find((s) => s.value === props.newStatus)?.text;
            return `${before} → ${after}`;
        });
        const props = __props;
        const emits = __emit;
        onMounted(async () => {
            if (props.contract?.jobId == null) {
                window.alert("案件IDが見つかりませんでした。");
                return;
            }
            await fetchCompanyUsersByJobId(props.contract.jobId);
            await fetchSuperAdminUser();
            setDefaultMessage();
        });
        const updateAndSentMessage = async () => {
            if (messageToCompanyUserIds.value.length === 0) {
                if (!window.confirm('企業ユーザーが選択されていません。企業ユーザーへメッセージが送信されなくても良いですか？')) {
                    return;
                }
            }
            else {
                if (!window.confirm('メッセージが送信されても良いですか？')) {
                    return;
                }
            }
            if (superAdminUser.value == null) {
                window.alert('運営ユーザーが見つかりませんでした。');
                return;
            }
            update();
            // メッセージの作成
            const messages = [];
            // 企業向けメッセージ送信
            if (messageToCompanyUserIds.value.length > 0 && messageToCompany.value !== '') {
                for (let i = 0; i < messageToCompanyUserIds.value.length; i++) {
                    const message = createMessageDto(superAdminUser.value.id, messageToCompanyUserIds.value[i], messageToCompany.value, '');
                    messages.push(message);
                }
            }
            // プランナー向けメッセージ送信
            if (messageToPlanner.value !== '' && props.contract?.plannerUserId != null) {
                const message = createMessageDto(superAdminUser.value.id, props.contract?.plannerUserId, messageToPlanner.value, '');
                messages.push(message);
            }
            console.log(messages);
            if (await storeMessages(messages)) {
                window.alert('メッセージを送信しました。');
            }
        };
        const update = async () => {
            if (props.contract == null || props.newStatus == null) {
                window.alert("契約情報が取得できませんでした。");
                return;
            }
            if (props.contract.status == props.newStatus) {
                window.alert("ステータスが変更されていません。");
                return;
            }
            const contractDto = createContractDtoFromModel(props.contract);
            contractDto.status = props.newStatus;
            try {
                await updateContracts([contractDto]);
            }
            catch (error) {
                window.alert(error.message);
            }
            window.alert('契約ステータスの変更を保存しました。');
            emits('updated');
        };
        const cancel = () => {
            emits('canceled');
        };
        const setDefaultMessage = () => {
            if (props.newStatus == null || props.contract?.status == null) {
                window.alert("ステータスの取得に失敗しました。");
                return;
            }
            const jobTitle = `【${props.contract?.jobSections}】${props.contract?.jobTitle}`;
            const plannerName = props.contract?.plannerName;
            messageToPlanner.value = jobTitle + 'についてのご連絡です。\n';
            messageToCompany.value = jobTitle + 'の' + plannerName + 'さんについてのご連絡です。\n';
            switch (props.newStatus) {
                case CONTRACT_STATUSES.find((s) => s.text === '選考中')?.value:
                    messageToPlanner.value += `企業があなたとの面談を希望しています。企業担当者へメッセージを送って、日程調整を開始していただけますでしょうか？`;
                    messageToCompany.value += `プロフィールのご確認ありがとうございます。\n面談を希望するプランナーとメッセージ機能で面談の日程調整を進めていただけますでしょうか？\n\n参考）\n\n面談日：\n面談方法：オンライン、対面（場所：）\n所要時間：\n事前に準備しておくもの：\nその他：`;
                    break;
                case CONTRACT_STATUSES.find((s) => s.text === '研修中')?.value:
                    messageToPlanner.value += `面談お疲れ様でした！\n今後、研修や会場見学がある場合は「シフト編集」画面から空いている日程を入力し、企業担当者へ入力した旨ご連絡をお願いします。`;
                    messageToCompany.value += `プランナーとの面談ありがとうございました。今後研修や会場見学を進めるにあたって、「出勤依頼」画面からプランナーの提出したシフトに見学・研修の依頼を行なってください。`;
                    break;
                case CONTRACT_STATUSES.find((s) => s.text === '稼働中')?.value:
                    messageToPlanner.value += `契約が成立しました。`;
                    messageToCompany.value += `契約が成立しました。`;
                    break;
                case CONTRACT_STATUSES.find((s) => s.text === '契約終了')?.value:
                    messageToPlanner.value += `契約が終了しました。`;
                    messageToCompany.value += `契約が終了しました。`;
                    break;
            }
        };
        return (_ctx, _cache) => {
            const _component_v_textarea = _resolveComponent("v-textarea");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_autocomplete = _resolveComponent("v-autocomplete");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_form = _resolveComponent("v-form");
            return (_openBlock(), _createBlock(_component_v_row, null, {
                default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                            _createElementVNode("h2", _hoisted_1, "契約のステータスを変更（" + _toDisplayString(title.value) + "）", 1),
                            _createVNode(_component_v_form, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "6" }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.contract?.plannerName) + " さん", 1),
                                                    _createVNode(_component_v_textarea, {
                                                        modelValue: messageToPlanner.value,
                                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((messageToPlanner).value = $event)),
                                                        label: "プランナーへのメッセージ",
                                                        type: "text",
                                                        variant: "outlined"
                                                    }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_col, { cols: "6" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_autocomplete, {
                                                        clearable: "",
                                                        chips: "",
                                                        multiple: "",
                                                        modelValue: messageToCompanyUserIds.value,
                                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((messageToCompanyUserIds).value = $event)),
                                                        label: "メッセージ送信先企業ユーザー",
                                                        items: _unref(companyUsers),
                                                        "item-title": "name",
                                                        "item-value": "userId"
                                                    }, null, 8, ["modelValue", "items"]),
                                                    _createVNode(_component_v_textarea, {
                                                        modelValue: messageToCompany.value,
                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((messageToCompany).value = $event)),
                                                        label: "クライアントへのメッセージ",
                                                        type: "text",
                                                        variant: "outlined"
                                                    }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_btn, {
                                        class: "mr-4",
                                        color: "primary",
                                        onClick: updateAndSentMessage,
                                        disabled: _unref(contracts).length > 0
                                    }, {
                                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                                            _createTextVNode("メッセージを送信して変更")
                                        ])),
                                        _: 1,
                                        __: [3]
                                    }, 8, ["disabled"]),
                                    _createVNode(_component_v_btn, {
                                        class: "mr-4",
                                        color: "secondary",
                                        onClick: update,
                                        disabled: _unref(contracts).length > 0
                                    }, {
                                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                                            _createTextVNode("メッセージを送信しないで変更")
                                        ])),
                                        _: 1,
                                        __: [4]
                                    }, 8, ["disabled"]),
                                    _createVNode(_component_v_btn, { onClick: cancel }, {
                                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                                            _createTextVNode("キャンセル")
                                        ])),
                                        _: 1,
                                        __: [5]
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
